<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 6383 6383"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="6383" height="6383" />
   <circle class="fil1" cx="3191" cy="3191" r="2950" />
   <g id="_577167784">
   <path class="fil2"
         d="M2702 2163c8,-33 7,-300 3,-346 -4,-50 -35,-84 -74,-98 -49,-17 -94,8 -136,25 -166,70 -319,168 -431,263 -218,184 -436,451 -551,835 -116,388 -82,834 76,1181 59,129 170,318 268,425 66,72 99,108 174,173 610,537 1528,575 2172,77l72 -58c12,-11 11,-12 23,-21 31,-24 64,-60 91,-87 16,-16 26,-25 44,-43 48,-48 152,-189 186,-247 89,-146 161,-294 209,-484 125,-489 28,-1001 -243,-1393 -67,-98 -195,-253 -283,-324 -16,-13 -31,-25 -48,-39 -151,-117 -246,-182 -432,-261 -42,-17 -87,-41 -136,-19 -39,18 -65,51 -67,105 -2,51 -5,307 5,340 15,48 44,62 90,84 347,166 596,530 649,914 46,329 -53,684 -261,928 -27,32 -53,64 -82,92 -386,383 -1020,493 -1528,154 -39,-26 -65,-48 -99,-74 -75,-58 -113,-103 -173,-174 -259,-306 -350,-801 -184,-1208 96,-237 265,-443 468,-572 95,-59 180,-78 198,-148z" />
     <path class="fil2"
           d="M3125 1153c-88,14 -153,70 -184,128 -45,82 -33,175 -33,275l0 1246c0,117 5,170 64,244 88,109 319,125 413,-48 43,-78 32,-181 32,-278l0 -1245c0,-114 -2,-170 -68,-241 -45,-50 -123,-97 -224,-81z" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: "AlarmOutput",
};
</script>

<style scoped>
.fil0 {
  fill: none
}

.fil2 {
  fill: #FEFEFE
}

.fil1 {
  fill: #56D6D1
}
</style>
